import type { ReactNode } from 'react';
import { create } from 'zustand';

/**
 * FixedChatWindow 内部的右侧抽屉内容。
 *
 * 全局的 RightDrawer（contexts/DrawerContext）渲染在根布局里，会被
 * FixedChatWindow 的全屏浮层（z-50）盖住。所以在非会话页（路径不是
 * /predic/c/ 开头）点卡片时，改用这个 store 把内容交给浮层内部的 Drawer 渲染。
 */
interface MarketDrawerState {
  isOpen: boolean;
  content: ReactNode | null;
  width: number;
  openMarketDrawer: (content: ReactNode, width?: number) => void;
  closeMarketDrawer: () => void;
}

const DEFAULT_WIDTH = 600;

export const useMarketDrawerStore = create<MarketDrawerState>((set) => ({
  isOpen: false,
  content: null,
  width: DEFAULT_WIDTH,
  openMarketDrawer: (content, width = DEFAULT_WIDTH) => set({ isOpen: true, content, width }),
  closeMarketDrawer: () => set({ isOpen: false, content: null, width: DEFAULT_WIDTH }),
}));
